export default __webpack_public_path__ + "static/media/website.7438f393.svg";